import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Modal from '~/Common-Objects/Modal/index'
import Row from '~/Common-Objects/Grids/Row/Row'
import FormatNumberFuncs from '../../../../../../Classes/numberFormatFunctions'
import i18n from '../../../../../../i18n'

export default function CampaignSendNow({ count, onConfirm, onCancel, social = false }) {
    return (
        <Modal width='800px' noClickAway={true}>
            <Row>
                <Column xs={12}>
                    <h4 className='mar-b10'>{i18n.t('campaigns:standard.step3.sendNow.header')}</h4>
                    <div className='mar-b25'>
                        {i18n.t('campaigns:standard.step3.sendNow.' + (social ? 'subheaderSocial' : 'subheader'), {
                            count: FormatNumberFuncs.formatNumber(count)
                        })}
                    </div>
                    <div className="quickFlex" style={{ gap: 8 }}>
                        <Button className='button-sml button-primary' iconLeft={<Icons icon="thumbsUp" />} onClick={onConfirm}>{i18n.t('campaigns:standard.step3.sendNow.confirm')}</Button>
                        <Button className='button-sml' onClick={onCancel}>{i18n.t('campaigns:standard.step3.sendNow.cancel')}</Button>
                    </div>
                </Column>
            </Row>
        </Modal>
    )
}